"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_VALIDATED_SINGLE_ITEM_VALIDATION_RESULT = exports.SingleItemValidationResultType = exports.CROSS_VALIDATION_TYPE_TO_DATA_TEST_IDS_MAP = exports.UCC_DECLINE_REWARDS_CARD_VALIDATION_KEYS = exports.HELOC_REFI_CREDIT_CARD_ACCOUNT_INFO_VALIDATION_KEYS = exports.AVEN_MY_CASH_OUT_DETAILS_CONFIRMATION_VALIDATION_KEYS = exports.HELOC_REFI_CLEAR_CONTINGENCY_VALIDATION_KEYS = exports.HELOC_REFI_POST_TRANSACTION_VALIDATION_KEYS = exports.HELOC_REFI_CREATE_WIRE_VALIDATION_KEYS = exports.HELOC_REFI_MOAP_OFFER_DETAILS_PAGE_DATA_TEST_IDS = exports.HELOC_REFI_MOAP_OFFER_PAGE_DATA_TEST_IDS = exports.HELOC_REFI_MOAP_PREQUAL_PAGE_DATA_TEST_IDS = exports.CrossValidationSkipReason = exports.CrossValidationResult = exports.CrossValidationType = void 0;
const dataTestId_1 = require("./dataTestId");
var CrossValidationType;
(function (CrossValidationType) {
    // HELOC refi related cross validations
    CrossValidationType["HELOC_REFI_MOAP_PREQUAL_PAGE"] = "HELOC_REFI_MOAP_PREQUAL_PAGE";
    CrossValidationType["HELOC_REFI_MOAP_OFFER_PAGE"] = "HELOC_REFI_MOAP_OFFER_PAGE";
    CrossValidationType["HELOC_REFI_MOAP_OFFER_DETAILS_PAGE"] = "HELOC_REFI_MOAP_OFFER_DETAILS_PAGE";
    CrossValidationType["HELOC_REFI_CREATE_WIRE_PAYOFF_VALIDATION"] = "HELOC_REFI_CREATE_WIRE_PAYOFF_VALIDATION";
    CrossValidationType["HELOC_REFI_POST_TRANSACTION_VALIDATION"] = "HELOC_REFI_POST_TRANSACTION_VALIDATION";
    CrossValidationType["HELOC_REFI_CLEAR_CONTINGENCY_VALIDATION"] = "HELOC_REFI_CLEAR_CONTINGENCY_VALIDATION";
    // Aven My / cardholder cross validations
    CrossValidationType["AVEN_MY_CASH_OUT_DETAILS_CONFIRMATION_VALIDATION"] = "AVEN_MY_CASH_OUT_DETAILS_CONFIRMATION_VALIDATION";
    CrossValidationType["HELOC_REFI_CREDIT_CARD_ACCOUNT_INFO_VALIDATION"] = "HELOC_REFI_CREDIT_CARD_ACCOUNT_INFO_VALIDATION";
    // UCC cross validations
    CrossValidationType["UCC_DECLINE_REWARDS_CARD_VALIDATION"] = "UCC_DECLINE_REWARDS_CARD_VALIDATION";
    CrossValidationType["UCC_ACCOUNT_AGREEMENT_SIGNING_VALIDATION"] = "UCC_ACCOUNT_AGREEMENT_SIGNING_VALIDATION";
    // Crypto cross validations
    CrossValidationType["CRYPTO_CONFIRM_OFFER_VALIDATION"] = "CRYPTO_CONFIRM_OFFER_VALIDATION";
    CrossValidationType["CRYPTO_UPDATE_LIMIT_VALIDATION"] = "CRYPTO_UPDATE_LIMIT_VALIDATION";
})(CrossValidationType || (exports.CrossValidationType = CrossValidationType = {}));
var CrossValidationResult;
(function (CrossValidationResult) {
    CrossValidationResult["PENDING"] = "PENDING";
    CrossValidationResult["SUCCEEDED"] = "SUCCEEDED";
    CrossValidationResult["FAILED"] = "FAILED";
})(CrossValidationResult || (exports.CrossValidationResult = CrossValidationResult = {}));
var CrossValidationSkipReason;
(function (CrossValidationSkipReason) {
    CrossValidationSkipReason["offerTermsNotAvailable"] = "offerTerms is not available";
})(CrossValidationSkipReason || (exports.CrossValidationSkipReason = CrossValidationSkipReason = {}));
exports.HELOC_REFI_MOAP_PREQUAL_PAGE_DATA_TEST_IDS = [
    dataTestId_1.DataTestId.preQualInfoHelocRefiTitle,
    dataTestId_1.DataTestId.preQualInfoHelocRefiOffer,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiCreditLimit,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiVarApr,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiCashBack,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiMaturityPeriodYears,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiPayoffFee,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiTransferAmount,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiApr,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiTeaserApr,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiRegularApr,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiTeaserMonthlyPayment,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiAfterTeaserMonthlyPayment,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiSecondLienMonthlyPayment,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiMonthlyPayment,
    dataTestId_1.DataTestId.preQualInfoOptionsHelocRefiMonthlyPaymentDecrease,
];
exports.HELOC_REFI_MOAP_OFFER_PAGE_DATA_TEST_IDS = [
    dataTestId_1.DataTestId.helocRefiFinalOffer,
    dataTestId_1.DataTestId.helocRefiFinalOfferCreditLimit,
    dataTestId_1.DataTestId.helocRefiFinalOfferVarApr,
    dataTestId_1.DataTestId.helocRefiFinalOfferCashback,
    dataTestId_1.DataTestId.helocRefiFinalOfferPayoffFee,
    dataTestId_1.DataTestId.helocRefiFinalOfferTransferAmount,
    dataTestId_1.DataTestId.helocRefiFinalOfferApr,
    dataTestId_1.DataTestId.helocRefiFinalOfferTeaserMonthlyPayment,
    dataTestId_1.DataTestId.helocRefiFinalOfferAfterTeaserMonthlyPayment,
    dataTestId_1.DataTestId.helocRefiFinalOfferMonthlyPayment,
];
exports.HELOC_REFI_MOAP_OFFER_DETAILS_PAGE_DATA_TEST_IDS = [
    dataTestId_1.DataTestId.productDetailsLineSize,
    dataTestId_1.DataTestId.productDetailsVariableApr,
    dataTestId_1.DataTestId.productDetailsPayoffFee,
    dataTestId_1.DataTestId.productDetailsPayoffAmount,
    dataTestId_1.DataTestId.productDetailsPayoffAmountWithoutFee,
    dataTestId_1.DataTestId.productDetailsPayoffFeeAmount,
    dataTestId_1.DataTestId.productDetailsFixedApr,
    dataTestId_1.DataTestId.productDetailsSecondLienAttestedMonthlyPayment,
    dataTestId_1.DataTestId.productDetailsEstimatedMonthlyPayment,
];
exports.HELOC_REFI_CREATE_WIRE_VALIDATION_KEYS = [
    'avenBalanceTransferSource',
    'avenBalanceTransferAmountRequested',
    'avenBalanceTransferAmount',
    'avenBalanceTransferTxnFee',
    'avenBalanceTransferTransferFee',
    'avenBalanceTransferFirstDrawFee',
    'avenBalanceTransferOriginationFee',
    'avenBalanceTransferOriginationFeeWithinCap',
    'avenBalanceTransferStatus',
    'helocRefiWirePaymentBeneficiary',
    'helocRefiWirePaymentWireReference',
    'helocRefiWirePaymentLienAccountNumber',
    'helocRefiWirePaymentLienHolderBankShortName',
    'helocRefiWirePaymentWireType',
    'helocRefiWirePaymentDestinationRoutingNumber',
    'helocRefiWirePaymentDestinationAccountNumber',
    'simpleInterestLoanLoanStartDate',
    'simpleInterestLoanTermInMonths',
    'simpleInterestLoanApr',
    'simpleInterestLoanAmount',
];
exports.HELOC_REFI_POST_TRANSACTION_VALIDATION_KEYS = [
    'avenBalanceTransferStatus',
    'avenBalanceTransferSource',
    'avenBalanceTransferCoreCardAccountNumber',
    'avenBalanceTransferPostSingleTransactionId',
    'avenBalanceTransferBtConfirmationNumber',
    'avenBalanceTransferPaymentInitiationDate',
    'helocRefiWirePaymentConfirmationNumber',
    'lienRefiPayoffStatus',
];
exports.HELOC_REFI_CLEAR_CONTINGENCY_VALIDATION_KEYS = ['contingencyCleared', 'lienRefisReleased'];
exports.AVEN_MY_CASH_OUT_DETAILS_CONFIRMATION_VALIDATION_KEYS = ['cashOutAmountRequested', 'cashOutTotalAmount', 'cashOutAprPercent', 'cashOutTermMonths'];
exports.HELOC_REFI_CREDIT_CARD_ACCOUNT_INFO_VALIDATION_KEYS = ['creditCardAccountLoanApplicationId', 'creditCardAccountRescissionEndDate'];
exports.UCC_DECLINE_REWARDS_CARD_VALIDATION_KEYS = [
    'creditCardAccountPresenceMatchesExpectation',
    'activeAccountClosureRequestPresent',
    'activeAccountClosureRequestReason',
    'loanApplicationInDeclinedStatus',
    'loanApplicationUpdateRationale',
];
exports.CROSS_VALIDATION_TYPE_TO_DATA_TEST_IDS_MAP = {
    [CrossValidationType.HELOC_REFI_MOAP_PREQUAL_PAGE]: exports.HELOC_REFI_MOAP_PREQUAL_PAGE_DATA_TEST_IDS,
    [CrossValidationType.HELOC_REFI_MOAP_OFFER_PAGE]: exports.HELOC_REFI_MOAP_OFFER_PAGE_DATA_TEST_IDS,
    [CrossValidationType.HELOC_REFI_MOAP_OFFER_DETAILS_PAGE]: exports.HELOC_REFI_MOAP_OFFER_DETAILS_PAGE_DATA_TEST_IDS,
    [CrossValidationType.HELOC_REFI_CREATE_WIRE_PAYOFF_VALIDATION]: [],
    [CrossValidationType.HELOC_REFI_POST_TRANSACTION_VALIDATION]: [],
    [CrossValidationType.HELOC_REFI_CLEAR_CONTINGENCY_VALIDATION]: [],
    [CrossValidationType.AVEN_MY_CASH_OUT_DETAILS_CONFIRMATION_VALIDATION]: [],
    [CrossValidationType.HELOC_REFI_CREDIT_CARD_ACCOUNT_INFO_VALIDATION]: [],
    [CrossValidationType.UCC_DECLINE_REWARDS_CARD_VALIDATION]: [],
    [CrossValidationType.UCC_ACCOUNT_AGREEMENT_SIGNING_VALIDATION]: [],
    [CrossValidationType.CRYPTO_CONFIRM_OFFER_VALIDATION]: [dataTestId_1.DataTestId.cryptoConfirmOfferCreditLimit, dataTestId_1.DataTestId.cryptoConfirmOfferApr],
    [CrossValidationType.CRYPTO_UPDATE_LIMIT_VALIDATION]: [dataTestId_1.DataTestId.cryptoUpdateLimitSuccessCreditLimit],
};
var SingleItemValidationResultType;
(function (SingleItemValidationResultType) {
    SingleItemValidationResultType["NOT_VALIDATED"] = "NOT_VALIDATED";
    SingleItemValidationResultType["MATCH"] = "MATCH";
    SingleItemValidationResultType["MISMATCH"] = "MISMATCH";
})(SingleItemValidationResultType || (exports.SingleItemValidationResultType = SingleItemValidationResultType = {}));
exports.NOT_VALIDATED_SINGLE_ITEM_VALIDATION_RESULT = { validationResult: SingleItemValidationResultType.NOT_VALIDATED };
